import React from "react";
import { Typography } from "@mui/material";
import { ListOfInputs } from "shared/components/Inputs/ListOfInputs";
import { SupportingInfo } from "modules/SupportingInfo/supportingInfo";
import { RelatedSupportingInfoInput } from "./RelatedSupportingInfoInput";

export interface RelatedSupportingInfoController {
  relatedInfos: SupportingInfo.PartialRelatedSupportingInfo[];
  infoOptions: SupportingInfo.SupportingInfo[];
  isLoadingInfoOptions: boolean;
  addSupportingInfo: () => void;
  handleSelectSupportingInfo: (index: number, infoId: number | string) => void;
  handleContentUpdate: (index: number, content: string) => void;
  handleTabNameUpdate: (index: number, tabName: string) => void;
  handleDeleteInfo: (index: number) => void;
  setIsSaving: (isSaving: boolean) => void;
}

interface RelatedSupportingInfosViewProps {
  controller: RelatedSupportingInfoController;
  hideContentEditing?: boolean;
  extraNote?: string;
}

export const RelatedSupportingInfosView = (props: RelatedSupportingInfosViewProps) => {
  const { controller, hideContentEditing, extraNote } = props;
  const {
    relatedInfos,
    infoOptions,
    isLoadingInfoOptions,
    addSupportingInfo,
    handleSelectSupportingInfo,
    handleContentUpdate,
    handleTabNameUpdate,
    handleDeleteInfo,
    setIsSaving,
  } = controller;

  return (
    <>
      {extraNote && (
        <Typography variant="body2" color="text.tertiary" mb={1}>
          {extraNote}
        </Typography>
      )}
      <ListOfInputs
        title="Supporting information"
        inputSections={[
          {
            addAction: { title: "Add Supporting information", onClick: () => addSupportingInfo() },
            inputs: relatedInfos.map((info, i) => ({
              inputElement: (
                <RelatedSupportingInfoInput
                  index={i}
                  info={info}
                  infoOptions={infoOptions}
                  onSelectSupportingInfo={handleSelectSupportingInfo}
                  onContentUpdate={handleContentUpdate}
                  onTabNameUpdate={handleTabNameUpdate}
                  isLoadingInfoOptions={isLoadingInfoOptions}
                  setIsSaving={setIsSaving}
                  hideContentEditing={hideContentEditing}
                />
              ),
              onDelete: () => handleDeleteInfo(i),
            })),
          },
        ]}
        onAddInput={() => addSupportingInfo()}
      />
    </>
  );
};
